import { useEffect, useMemo, useRef } from 'react';

export type Hook<HookReturn = any, HookArgs extends any[] = any[]> = {
    // начальное возвращаемое значение хука (до фактического вызова хука)
    initValue: HookReturn;
    // хук, который мы хотим сделать синглтоном
    useHookBody: (...args: HookArgs) => HookReturn;
    // функция, которая информирует всех потребителей хука о любом изменении возвращаемого значения хук
    applyStateChange: (newState: HookReturn) => void;
    // аргументы, которые передаются хуку при его использовании
    args: HookArgs;
};


// компонент рендерится внутри SingletonHooksContainer для каждого хука
// компонент будет хранить возвращаемое значение хука и применять изменения ко всем потребителям всякий раз,
// когда оно изменяется
export const SingleItemContainer = ({
    initValue,
    useHookBody,
    applyStateChange,
    args = [],
}: Hook) => {
    const lastState = useRef(initValue);
    if (typeof useHookBody !== 'function') {
        throw new Error(
            `функция ожидается как параметр тела хука: got type ${typeof useHookBody}`
        );
    }

    const hookReturn = useHookBody(...args);
    const hookReturnValue = useMemo(()=> JSON.stringify(hookReturn), [hookReturn]);

    useEffect(() => {
        // применить изменение к потребителям, если значение изменилось
        if (lastState.current !== hookReturn) {
            lastState.current = hookReturn;
            applyStateChange(hookReturn);
        }
    }, [applyStateChange, hookReturnValue]); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};
